module.exports = __webpack_public_path__ + "fonts/fd397187-4d65-4b13-99ac-e43b94abebcc.15813ef2.eot";